import Vue from 'vue'
import Vuex from 'vuex'
import {getStorage, setStorage } from '@/storage'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin:false,
    subUnitSize: 'mini',
    unit: [],
    goodsTypeArr: [],
    merchantArr: [],
    areaArr: [],
    routerArr:[
      {
        path: '/home/index',
        title: '首页'
      }
    ],
    is_sys: getStorage('is_sys') || '',
    invoiceRead:0, //开票未读
    paymentProcessRead:0, //付款未读
    wait_order:0, //订单列表菜单小红点
    wait_purchase:0, //采购审核菜单小红点
    user_check_count: 0,//用户管理-审核列表小红点数量
    financeAccountList:['19398669675','19398669635'], //写死的账务账号 会计 出纳
  },
  mutations: {
    setUnit: (state, payload) => state.unit = payload,
    setGoodsType: (state, payload) => state.goodsTypeArr = payload,
    setMerchant: (state, payload) => state.merchantArr = payload,
    setArea: (state, payload) => state.areaArr = payload,
    setRouterArr(state, payload) {
      let o =state.routerArr.some(item=>{
        return item.path == payload.path;
      })
      !o && state.routerArr.push(payload)
    },
    set_is_sys: (state, payload) => {
      state.is_sys = payload;
      setStorage('is_sys', payload)
    },
    set_invoiceRead: (state, payload) => {
      state.invoiceRead = payload;
    },
    set_paymentProcessRead: (state, payload) => {
      state.paymentProcessRead = payload;
    },
    set_wait_order: (state, payload) => {
      state.wait_order = payload;
    },
    set_wait_purchase: (state, payload) => {
      state.wait_purchase = payload;
    },
    set_user_check_count: (state, payload) => {
      state.user_check_count = payload;
    },
  },
  actions: {
  },
  getters: {
    unit: state => state.unit,
    goodsTypeArr: state => state.goodsTypeArr,
    merchantArr: state => state.merchantArr,
    areaArr: state => state.areaArr,
    routerArr: state => state.routerArr,
    routerArr: state => state.routerArr,
    is_sys: state => state.is_sys,
  },
  modules: {
  },
})
